export var BlockElementType;
(function (BlockElementType) {
    BlockElementType["BUTTON"] = "button";
    BlockElementType["IMAGE"] = "image";
    BlockElementType["OVERFLOW"] = "overflow";
    /** @deprecated */
    BlockElementType["OVERFLOW_MENU"] = "overflow";
    BlockElementType["PLAIN_TEXT_INPUT"] = "plain_text_input";
    BlockElementType["STATIC_SELECT"] = "static_select";
    BlockElementType["MULTI_STATIC_SELECT"] = "multi_static_select";
    /** @deprecated */
    BlockElementType["CONVERSATION_SELECT"] = "conversations_select";
    /** @deprecated */
    BlockElementType["CHANNEL_SELECT"] = "channels_select";
    /** @deprecated */
    BlockElementType["USER_SELECT"] = "users_select";
    BlockElementType["CONVERSATIONS_SELECT"] = "conversations_select";
    BlockElementType["CHANNELS_SELECT"] = "channels_select";
    BlockElementType["USERS_SELECT"] = "users_select";
    BlockElementType["DATEPICKER"] = "datepicker";
    BlockElementType["LINEAR_SCALE"] = "linear_scale";
    BlockElementType["MULTI_CHANNELS_SELECT"] = "multi_channels_select";
    BlockElementType["MULTI_CONVERSATIONS_SELECT"] = "multi_conversations_select";
    BlockElementType["MULTI_USERS_SELECT"] = "multi_users_select";
    BlockElementType["TOGGLE_SWITCH"] = "toggle_switch";
    BlockElementType["RADIO_BUTTON"] = "radio_button";
    BlockElementType["CHECKBOX"] = "checkbox";
    BlockElementType["TIME_PICKER"] = "time_picker";
    BlockElementType["TAB"] = "tab";
})(BlockElementType || (BlockElementType = {}));
//# sourceMappingURL=BlockElementType.js.map